import { createContext, useContext, useReducer } from 'react';
import { SET_SESSION, CLEAR_SESSION, LOGOUT } from '@/actions/types';

const AuthContext = createContext(null);
const AuthDispatchContext = createContext(null);

const initialState = {
  isLoggedIn: false,
  explicitlyLoggedOut: false,
};

function authReducer(state, action) {
  switch (action.type) {
    case SET_SESSION: {
      return Object.assign({}, action.session, { isLoggedIn: true, explicitlyLoggedOut: false });
    }
    case CLEAR_SESSION: {
      return { isLoggedIn: false, explicitlyLoggedOut: false };
    }
    case LOGOUT: {
      return { isLoggedIn: false, explicitlyLoggedOut: true };
    }
    default: {
      throw Error('Unknown action: ' + action.type);
    }
  }
}

export function AuthProvider({ children }) {
  const [session, dispatch] = useReducer(authReducer, initialState);

  return (
    <AuthContext.Provider value={session}>
      <AuthDispatchContext.Provider value={dispatch}>
        {children}
      </AuthDispatchContext.Provider>
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}

export function useAuthDispatch() {
  const dispatch = useContext(AuthDispatchContext);
  if (!dispatch) {
    throw new Error('useAuthDispatch must be used within AuthProvider');
  }
  return dispatch;
}
